import { BaseChartProps, BasePieChartProps } from '../types';
import { defaultChartColors } from './colors';

export function applyColors(options: Highcharts.Options, props: BaseChartProps | BasePieChartProps) {
  options.colors = props.colors || defaultChartColors;
  return options;
}
